import FlyerAdultBirthdayTile from './Assets/flyerTiles/tile_adultbirthday.jpg';
import FlyerBabyShowerTile from './Assets/flyerTiles/tile_babyshower.jpg';
import FlyerBacheloretteTile from './Assets/flyerTiles/tile_bachelorette.jpg';
import FlyerBarbecueTile from './Assets/flyerTiles/tile_barbecue.jpg';
import FlyerBMitzvahTile from './Assets/flyerTiles/tile_bmitzvah.jpg';
import FlyerEngagementPartyTile from './Assets/flyerTiles/tile_engagementparty.jpg';
import FlyerHousewarmingTile from './Assets/flyerTiles/tile_housewarming.jpg';
import FlyerKidsBirthdayTile from './Assets/flyerTiles/tile_kidsbirthday.jpg';
import FlyerPoolPartyTile from './Assets/flyerTiles/tile_poolparty.jpg';
import FlyerPrideTile from './Assets/flyerTiles/tile_pride.jpg';
import FlyerProfessionalTile from './Assets/flyerTiles/tile_professional.jpg';
import FlyerSaveTheDatesTile from './Assets/flyerTiles/tile_savethedates.jpg';
import FlyerWeddingInvitationsTile from './Assets/flyerTiles/tile_weddinginvitations.jpg';
import FlyerWeddingShowerTile from './Assets/flyerTiles/tile_weddingshower.jpg';
import Flyer4thOfJulyTile from './Assets/flyerTiles/tile_july4.jpg';
import FlyerSummerPartyTile from './Assets/flyerTiles/tile_summerparty.jpg';

import AppPromo_Mobile from './Assets/AppPromo_Mobile.png';

import OnlineCardsPromo_Mobile from './Assets/OnlineCardsPromo_Mobile.jpg';

import PartyShop from './Assets/PartyShop.jpg';
import PartyShop_Mobile from './Assets/PartyShop_Mobile.jpg';

import Block1 from './Assets/Block1.png';
import Block1_Mobile from './Assets/Block1_Mobile.png';
import Block2 from './Assets/Block2.png';
import Block2_Mobile from './Assets/Block2_Mobile.png';
import Block3 from './Assets/Block3.png';
import Block3_Mobile from './Assets/Block3_Mobile.png';
import Block4 from './Assets/Block4.png';
import Block4_Mobile from './Assets/Block4_Mobile.png';

import PaperSourceImage from '../Shared/PaperSource/PaperSourceWeddingBanner.jpg';
import PaperSourceLogo from '../Shared/PaperSource/PaperSourceLogo.png';

import UYODesktopVideo from './Assets/UYODesktopVideo.mp4';
import UYOMobileVideo from './Assets/UYOMobileVideo.mp4';
import UYODesktopPoster from './Assets/UYODesktopPoster.jpg';
import UYOMobilePoster from './Assets/UYOMobilePoster.jpg';

import CardsPoster from './Assets/CardsPoster.jpg';
import CardsVideo from './Assets//CardsVideo.mp4';
import FlyerPoster from './Assets/FlyerPoster.jpg';
import FlyerVideo from './Assets/FlyerVideo.mp4';

import MobileHeroPoster from './Assets/MobileHeroPoster.jpg';
import MobileHeroVideo from './Assets/MobileHeroVideo.mp4';
import DesktopHeroPoster from './Assets/DesktopHeroPoster.jpg';
import DesktopHeroVideo from './Assets/DesktopHeroVideo.mp4';

import {
  SQUARE_BUTTON_TYPE,
  UNDERLINE_BUTTON_TYPE,
  WHITE_BUTTON_COLOR,
  BLACK_BUTTON_COLOR,
  LARGE_SIZE,
} from '../../../components/SlatButton';

import getAppUrl from '../../../utils/getAppUrl';
import { SIZE_SM } from '../../../utils/screens';

const PageData = {
  seo: {
    title: 'Online Invitations, Cards, and Flyers | Paperless Post',
    description:
      'Customize online Card invitations, Flyers, and greetings that reflect your personal style—for weddings, holidays, birthdays, and all the moments that matter.',
    url: `${getAppUrl()}`,
    canonicalUrl: `${getAppUrl()}`,
  },

  HOME_HERO: {
    titleDesktop: 'Online invitations to celebrate all of life’s\u00a0moments',
    titleMobile: 'Online invitations to celebrate all of life’s\u00a0moments',
    mobilePoster: MobileHeroPoster,
    mobileVideo: MobileHeroVideo,
    poster: DesktopHeroPoster,
    video: DesktopHeroVideo,
    navButtons: [
      {
        className: 'hidden md:inline-block',
        type: UNDERLINE_BUTTON_TYPE,
        color: WHITE_BUTTON_COLOR,
        size: LARGE_SIZE,
        href: '/cards/category/4th-of-july-invitations',
        as: 'AppLink',
        children: '4th of July',
        tracking: {
          id: '4th of July',
          block_name: 'home-hero',
          block_row: 1,
        },
      },
      {
        className: 'hidden md:inline-block',
        type: UNDERLINE_BUTTON_TYPE,
        color: WHITE_BUTTON_COLOR,
        size: LARGE_SIZE,
        href: '/cards/group/wedding-invitations ',
        as: 'AppLink',
        children: 'Wedding',
        tracking: {
          id: 'Wedding',
          block_name: 'home-hero',
          block_row: 1,
        },
      },
      {
        className: 'hidden md:inline-block',
        type: UNDERLINE_BUTTON_TYPE,
        color: WHITE_BUTTON_COLOR,
        size: LARGE_SIZE,
        href: '/cards/category/kids-birthday-invitations',
        as: 'AppLink',
        children: 'Kids’ birthday',
        tracking: {
          id: 'Kids’ birthday',
          block_name: 'home-hero',
          block_row: 1,
        },
      },
      {
        className: 'hidden md:inline-block',
        type: UNDERLINE_BUTTON_TYPE,
        color: WHITE_BUTTON_COLOR,
        size: LARGE_SIZE,
        href: '/cards/category/baby-shower-invitations',
        as: 'AppLink',
        children: 'Baby shower',
        tracking: {
          id: 'Baby shower',
          block_name: 'home-hero',
          block_row: 1,
        },
      },
      {
        className: 'hidden md:inline-block',
        type: UNDERLINE_BUTTON_TYPE,
        color: WHITE_BUTTON_COLOR,
        size: LARGE_SIZE,
        href: '/cards/section/invitations',
        as: 'AppLink',
        children: 'Browse all',
        tracking: {
          id: 'Browse now',
          block_name: 'home-hero',
          block_row: 1,
        },
      },
      {
        className: 'md:hidden',
        type: UNDERLINE_BUTTON_TYPE,
        color: WHITE_BUTTON_COLOR,
        size: LARGE_SIZE,
        href: '/cards/section/invitations',
        as: 'AppLink',
        children: 'Get started',
        tracking: {
          id: 'Get started',
          block_name: 'home-hero',
          block_row: 1,
        },
      },
    ],
  },

  FLYER_CATEGORY_TILES: [
    {
      name: 'Kids’ birthday',
      href: '/cards/category/kids-birthday-invitations',
      image: FlyerKidsBirthdayTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Kids’ birthday',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: '4th of July',
      href: '/cards/category/4th-of-july-invitations',
      image: Flyer4thOfJulyTile,
      aspectRatio: '53.3%',
      tracking: {
        id: '4th of July',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Adult birthday',
      href: '/cards/category/adult-birthday-invitations',
      image: FlyerAdultBirthdayTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Adult birthday',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Baby shower',
      href: '/cards/category/baby-shower-invitations',
      image: FlyerBabyShowerTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Baby shower',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Pool party',
      href: '/cards/category/pool-party-invitations',
      image: FlyerPoolPartyTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Pool party',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Barbecue',
      href: '/cards/category/barbecue-invitations',
      image: FlyerBarbecueTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Barbecue',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Bridal shower',
      href: '/cards/category/bridal-shower-invitations',
      image: FlyerWeddingShowerTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Bridal shower',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Pride',
      href: '/cards/category/pride-party-invitations',
      image: FlyerPrideTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Pride',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Wedding invitations',
      href: '/cards/group/wedding-invitations',
      image: FlyerWeddingInvitationsTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Wedding invitations',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Save the dates',
      href: '/cards/group/save-the-dates',
      image: FlyerSaveTheDatesTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Save the dates',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Bachelorette',
      href: '/cards/category/bachelorette-party-invitations',
      image: FlyerBacheloretteTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Bachelorette',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Summer parties',
      href: '/cards/category/summer-entertaining-invitations',
      image: FlyerSummerPartyTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Summer parties',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Housewarming',
      href: '/cards/category/housewarming-party-invitations',
      image: FlyerHousewarmingTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Housewarming',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Bat & bar mitzvah',
      href: '/cards/category/bar-and-bat-mitzvah-invitations',
      image: FlyerBMitzvahTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Bat & bar mitzvah',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Engagement party',
      href: '/cards/category/engagement-party-invitations',
      image: FlyerEngagementPartyTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Engagement party',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
    {
      name: 'Professional',
      href: '/cards/group/business-event-invitations',
      image: FlyerProfessionalTile,
      aspectRatio: '53.3%',
      tracking: {
        id: 'Professional',
        block_name: 'flyer-category-tiles',
        block_row: 1,
      },
    },
  ],

  APP_PROMO: {
    className: 'mx-4 bg-[#eeeeee]',
    theme: 'default',
    tag: 'div',
    content: [
      {
        className: 'theme-default-content',
        tag: 'div',
        content: [
          {
            tag: 'title_2',
            className: 'heading-medium pt-4',
            children: 'Get the party started faster with the app',
          },
        ],
      },
      {
        tag: 'a',
        href: 'https://paperlesspost.app.link/wv5zGFkP8ab',
        tracking: {
          id: 'mobile_home_app_promo',
          block_name: 'app-promo',
          block_row: 1,
        },
        content: [
          {
            className: 'theme-default-media',
            tag: 'image',
            image: AppPromo_Mobile,
            mobileImage: AppPromo_Mobile,
            aspectRatio: '64%',
            mobileAspectRatio: '64%',
          },
        ],
      },
    ],
  },

  PARTYSHOP_BANNER: {
    className: 'mx-4 md:mx-6',
    theme: 'default',
    tag: 'div',
    content: [
      {
        tag: 'a',
        href: 'https://partyshop.paperlesspost.com/?utm_source=paperlesspost&utm_medium=homepage',
        target: '_blank',
        tracking: {
          id: 'party_shop_banner',
          block_name: 'party-shop-kbd',
          block_row: 1,
        },
        content: [
          {
            tag: 'image',
            imageClassName: 'w-full',
            image: PartyShop,
            mobileImage: PartyShop_Mobile,
            aspectRatio: '33.6%',
            mobileAspectRatio: '66.5%',
          },
        ],
      },
    ],
  },

  MOBILE_HERO_PROMO: {
    className: '',
    theme: 'default',
    tag: 'div',
    content: [
      {
        className: 'theme-default-content slat-content-basis pb-4',
        tag: 'div',
        content: [
          {
            className: 'header heading-serif-medium',
            tag: 'title_2',
            children: 'Birthdays and beyond',
          },
          {
            tag: 'p',
            className: 'dek',
            children: 'Celebrate with thoughtful cards and thank\u00a0yous.',
          },
          {
            tag: 'button',
            as: 'link',
            className: 'button pt-2',
            children: 'Browse now',
            type: UNDERLINE_BUTTON_TYPE,
            color: BLACK_BUTTON_COLOR,
            size: LARGE_SIZE,
            href: '/cards/group/greeting-cards',
            tracking: {
              id: 'Browse cards',
              block_name: 'hero_cards_send_a_card',
              block_row: 1,
            },
          },
        ],
      },
      {
        className: 'theme-default-media',
        tag: 'image',
        image: OnlineCardsPromo_Mobile,
        mobileImage: OnlineCardsPromo_Mobile,
        aspectRatio: '40.43%',
        mobileAspectRatio: '40.43%',
      },
    ],
  },

  PRODUCT_COMPARISON: {
    cards: {
      video: {
        poster: CardsPoster,
        src: CardsVideo,
      },
      title: 'Cards',
      description: 'Classic stationery-inspired designs',
      features: [
        'Elevate your event with curated envelopes, liners, and stamps',
        'Exclusive partner collections with world-class designers',
        'Send in minutes via email, text, or shareable link',
      ],
      link: {
        tag: 'button',
        type: UNDERLINE_BUTTON_TYPE,
        color: BLACK_BUTTON_COLOR,
        size: LARGE_SIZE,
        href: '/cards/section/invitations',
        as: 'AppLink',
        children: 'Browse Cards',
        tracking: {
          id: 'Browse Cards',
          block_name: 'product-comparison',
          block_row: 2,
        },
      },
    },
    flyers: {
      video: {
        poster: FlyerPoster,
        src: FlyerVideo,
      },
      title: 'Flyer',
      description: 'Casual, animated invite templates',
      features: [
        'Customize any template with photos, GIFs, stickers, and fonts',
        'Hundreds of free designs for any occasion',
        'Send in minutes via email, text, or shareable link',
      ],
      link: {
        tag: 'button',
        type: UNDERLINE_BUTTON_TYPE,
        color: BLACK_BUTTON_COLOR,
        size: LARGE_SIZE,
        href: '/flyer',
        as: 'AppLink',
        children: 'Browse Flyer',
        tracking: {
          id: 'Browse Flyer',
          block_name: 'product-comparison',
          block_row: 2,
        },
      },
    },
  },

  MASONRY_CATEGORIES: [
    {
      title: 'Introducing Lisa Corti',
      href: ' /cards/group/lisa-corti',
      image: Block1,
      mobileImage: Block1_Mobile,
      aspectRatio: '34.8%',
      mobileAspectRatio: '34.8%',
      backgroundColor: '#F6F5C9',
      tracking: {
        id: 'Introducing Lisa Corti',
        block_name: 'masonry-categories',
        block_row: 3,
      },
    },
    {
      title: 'Baby shower',
      href: '/cards/category/baby-shower-invitations',
      image: Block2,
      mobileImage: Block2_Mobile,
      aspectRatio: '140%',
      mobileAspectRatio: '140%',
      backgroundColor: '#BCD1B0',
      tracking: {
        id: 'Baby shower',
        block_name: 'masonry-categories',
        block_row: 3,
      },
    },
    {
      title: 'Wedding shower',
      href: '/cards/category/bridal-shower-invitations',
      image: Block3,
      mobileImage: Block3_Mobile,
      aspectRatio: '140%',
      mobileAspectRatio: '140%',
      backgroundColor: '#D6E7ED',
      tracking: {
        id: 'Wedding shower',
        block_name: 'masonry-categories',
        block_row: 3,
      },
    },
    {
      title: 'Adult birthday',
      href: '/cards/category/adult-birthday-invitations',
      image: Block4,
      mobileImage: Block4_Mobile,
      aspectRatio: '34.8%',
      mobileAspectRatio: '34.8%',
      backgroundColor: '#D4CEE6',
      tracking: {
        id: 'Adult birthday',
        block_name: 'masonry-categories',
        block_row: 3,
      },
    },
  ],

  DESIGNER_COLLECTIONS: {
    title: {
      className: 'heading-medium lg:heading-large xl:heading-xlarge 2xl:heading-xxlarge mt-6 mb-10',
      tag: 'title_2',
      children: 'Designer collections',
    },
    className: 'mx-4 mb-4 md:mx-6 md:mb-6',
    categories: [
      {
        title: 'Lisa Corti',
        href: '/cards/group/lisa-corti',
        backgroundColor: '#E6D975',
        images: [
          {
            image:
              'https://assets.ppassets.com/p-4jr751HV7MgjhyxpWLztWB/flyer/media_asset/jpeg_large',
            mobileImage:
              'https://assets.ppassets.com/p-4jr751HV7MgjhyxpWLztWB/flyer/media_asset/jpeg_large',
            shape: 'tall',
          },
        ],
        tracking: {
          id: 'designer-lisa-corti',
          block_name: 'designer-collections',
          block_row: 6,
        },
      },
      {
        title: 'Oscar de la Renta',
        href: '/cards/group/oscar-de-la-renta',
        backgroundColor: '#F0E9E0',
        images: [
          {
            image:
              'https://assets.ppassets.com/p-5VuTnJ359vPvmdPIH23FLj/flyer/media_asset/jpeg_large',
            mobileImage:
              'https://assets.ppassets.com/p-5VuTnJ359vPvmdPIH23FLj/flyer/media_asset/jpeg_large',
            shape: 'tall',
          },
        ],
        tracking: {
          id: 'designer-oscar-de-la-renta',
          block_name: 'designer-collections',
          block_row: 6,
        },
      },
      {
        title: 'Rifle Paper Co.',
        href: '/cards/group/rifle-paper-co',
        backgroundColor: '#C0D6D0',
        images: [
          {
            image:
              'https://assets.ppassets.com/p-bYl9B6XvGbXbEp41YcPpU/flyer/media_asset/jpeg_large',
            mobileImage:
              'https://assets.ppassets.com/p-bYl9B6XvGbXbEp41YcPpU/flyer/media_asset/jpeg_large',
            shape: 'tall',
          },
        ],
        tracking: {
          id: 'designer-rifle_paper_co',
          block_name: 'designer-collections',
          block_row: 6,
        },
      },
      {
        title: 'Monique Lhuillier',
        href: '/cards/group/monique-lhuillier',
        backgroundColor: '#EACFD4',
        images: [
          {
            image:
              'https://assets.ppassets.com/p-e3lAjktOwmCCkbdNgndeo/flyer/media_asset/jpeg_large',
            mobileImage:
              'https://assets.ppassets.com/p-e3lAjktOwmCCkbdNgndeo/flyer/media_asset/jpeg_large',
            shape: 'tall',
          },
        ],
        tracking: {
          id: 'designer-monique-lhuillier',
          block_name: 'designer-collections',
          block_row: 6,
        },
      },
    ],
    button: {
      tag: 'button',
      className: 'm-4',
      type: SQUARE_BUTTON_TYPE,
      color: BLACK_BUTTON_COLOR,
      size: LARGE_SIZE,
      as: 'AppLink',
      children: 'Browse all designers',
      href: '/partners',
      tracking: {
        id: 'Browse all designers',
        block_name: 'designer-collections',
        block_row: 6,
      },
    },
  },

  UYO_SLAT: {
    className:
      'theme-small-switch-content-left theme-small-switch-slat bg-[#c9d9e6] relative md:h-[430px] my-4 mx-4 lg:mx-6 lg:my-6',
    theme: 'small-switch',
    tag: 'div',
    content: [
      {
        tag: 'video',
        theme: 'default',
        className: 'w-full md:absolute inset-0 md:h-[430px]',
        videoClassName:
          'w-full md:h-[430px] md:absolute md:object-cover md:object-[65%_bottom] lg:object-[85%_bottom]  md:inset-0',
        video: UYODesktopVideo,
        mobileVideo: UYOMobileVideo,
        image: UYODesktopPoster,
        mobileImage: UYOMobilePoster,
        mobileSizeList: [SIZE_SM],
        aspectRatio: '30.94%',
        mobileAspectRatio: '96.79%',
      },
      {
        className: 'hidden md:block theme-small-switch-media md:h-[430px]',
        tag: 'div',
      },
      {
        className:
          'theme-small-switch-content slat-content-basis md:items-start md:h-[430px] md:px-[1.5rem] lg:px-[3rem] xl:px-[5rem] md:px-0 md:max-w-[70%] lg:max-w-[60%] xl:max-w-[50%]',
        tag: 'div',
        theme: 'customized',
        content: [
          {
            className:
              'w-full text-black md:text-left heading-large md:top-auto lg:heading-xlarge xl:heading-xxlarge !font-normal',
            tag: 'title_2',
            children: 'Plan any professional event smarter',
          },
          {
            className: 'text-black my-6 md:text-left paragraph-medium lg:paragraph-large',
            tag: 'p',
            children:
              'Our sophisticated customization and management tools put your brand front and center—and make hosting more streamlined than ever.',
          },
          {
            className: '!mt-0 button uppercase text-black font-mono font-thin text-sm',
            tag: 'button',
            type: UNDERLINE_BUTTON_TYPE,
            color: BLACK_BUTTON_COLOR,
            as: 'AppLink',
            children: 'Get started',
            href: '/pro',
            tracking: {
              id: 'Get started',
              block_name: 'uyo',
              block_row: 7,
            },
          },
        ],
      },
    ],
  },

  PAPER_SOURCE_PROMO: {
    className: 'theme-default-content-left m-4 md:m-6 bg-[#f9ece7]',
    theme: 'default',
    tag: 'div',
    content: [
      {
        className: 'theme-default-media',
        tag: 'image',
        image: PaperSourceImage,
        imageClassName: 'w-full',
        aspectRatio: '66.7%',
        mobileImage: PaperSourceImage,
        mobileAspectRatio: '66.7%',
      },
      {
        className: 'theme-default-content slat-content-basis',
        tag: 'div',
        content: [
          {
            className: 'w-36 xl:w-56 kicker',
            tag: 'image',
            image: PaperSourceLogo,
            aspectRatio: '10.8%',
            mobileImage: PaperSourceLogo,
            mobileAspectRatio: '10.8%',
          },
          {
            tag: 'title_2',
            className: 'header mb-2',
            children: 'Printed wedding invitations',
          },
          {
            className: 'dek',
            tag: 'p',
            children:
              'We’ve partnered with Paper Source to provide paper versions of our digital\u00A0designs.',
          },
          {
            className: 'button',
            tag: 'button',
            type: SQUARE_BUTTON_TYPE,
            color: BLACK_BUTTON_COLOR,
            size: LARGE_SIZE,
            as: 'AppLink',
            children: 'Shop at Paper Source',
            href: 'http://www.kqzyfj.com/click-7152784-13097460',
            tracking: {
              block_name: 'paper-source-banner',
              block_row: 8,
            },
          },
        ],
      },
    ],
  },

  BLOG_POSTS: {
    className: 'm-4 md:m-6',
    tags: '592',
    tracking: {
      block_name: 'blogPosts',
      block_row: 9,
    },
  },
};

export default PageData;
